
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class AccountReceivableService {
  constructor() {}

  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.acc_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_AR_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static createAndApproveAccountReceivableFromInvoice(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAndApproveAccountReceivableFromInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApproveAccountReceivable(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAndApproveAccountReceivable",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApproveAccountReceivable(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateAndApproveAccountReceivable",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readAccountReceivablePaymentLinesForInvoice(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readAccountReceivablePaymentLinesForInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getAccountReceivablePageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getAccountReceivablePageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readandLockAccountReceivable(input, responseCallBack, errorCallBack) {
    this.method(
      "readandLockAccountReceivable",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAccountReceivable(input, responseCallBack, errorCallBack) {
    this.method(
      "updateAccountReceivable",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAccountReceivable(input, responseCallBack, errorCallBack) {
    this.method(
      "createAccountReceivable",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readAccountReceivableDependenciesOfCustomer(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readAccountReceivableDependenciesOfCustomer",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockAccountReceivableNumber(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockAccountReceivableNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelAccountReceivable(input, responseCallBack, errorCallBack) {
    this.method(
      "cancelAccountReceivable",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static reverseAccountReceivable(input, responseCallBack, errorCallBack) {
    this.method(
      "reverseAccountReceivable",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approveAccountReceivable(input, responseCallBack, errorCallBack) {
    this.method(
      "approveAccountReceivable",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readAccountReceivablePaymentLinesForCreditMemo(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readAccountReceivablePaymentLinesForCreditMemo",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAccountReceivableFromCreditMemo(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAccountReceivableFromCreditMemo",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initAccountReceivableModule(input, responseCallBack, errorCallBack) {
    this.method(
      "initAccountReceivableModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCheckBounceDetailForCustomerStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getCheckBounceDetailForCustomerStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPaymentHistoryDetailsForInvoice(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPaymentHistoryDetailsForInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getUnPostedARDetailsForInvoices(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getUnPostedARDetailsForInvoices",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static fetchAccountReceivableMailDefaultInfoBean(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "fetchAccountReceivableMailDefaultInfoBean",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static sendAccountReceivableMail(input, responseCallBack, errorCallBack) {
    this.method(
      "sendAccountReceivableMail",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getCheckBounceProcessPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getCheckBounceProcessPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initCheckBounceProcessModule(input, responseCallBack, errorCallBack) {
    this.method(
      "initCheckBounceProcessModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createCheckBounceProcess(input, responseCallBack, errorCallBack) {
    this.method(
      "createCheckBounceProcess",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateCheckBounceProcess(input, responseCallBack, errorCallBack) {
    this.method(
      "updateCheckBounceProcess",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockCheckBounceProcessCode(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockCheckBounceProcessCode",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCheckBounceDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "readCheckBounceDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApproveAccountReceivableForInvoicePayment(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAndApproveAccountReceivableForInvoicePayment",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPostDatedCheckEntry(input, responseCallBack, errorCallBack) {
    this.method(
      "createPostDatedCheckEntry",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePostDatedCheckEntry(input, responseCallBack, errorCallBack) {
    this.method(
      "updatePostDatedCheckEntry",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initPostDatedCheckEntryModule(input, responseCallBack, errorCallBack) {
    this.method(
      "initPostDatedCheckEntryModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelPostDatedCheckEntry(input, responseCallBack, errorCallBack) {
    this.method(
      "cancelPostDatedCheckEntry",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApprovePostDatedCheckEntry(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAndApprovePostDatedCheckEntry",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApprovePostDatedCheckEntry(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateAndApprovePostDatedCheckEntry",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockPostDatedCheckEntryNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "unLockPostDatedCheckEntryNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unApprovePostDatedCheckEntry(input, responseCallBack, errorCallBack) {
    this.method(
      "unApprovePostDatedCheckEntry",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPostDatedCheckEntryPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPostDatedCheckEntryPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getUnPostedARDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getUnPostedARDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.acc_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
       ServiceExecutorProxy.executeService(methodName, input,this.acc_data_url,responseCallBack, errorCallBack);
        
    }
  }
}
